<template>
  <div class="search_list">
    <div class="result_item" v-for="(item,index) of list" :key="index">
      <div class="item_title">
        <span class="title">{{item.title}}</span>
        <slot name="tag" :item="item"></slot>
      </div>
      <div class="detail">
        <p v-for="(list,j) of detailLists" :key="j" class="detail_item">
          <span>{{list.label}}:&nbsp &nbsp</span>
          <span>{{item[list.key]}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },

    detailLists: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.result_item {
  background: #ffffff;
  border: 1px solid #dee2e6;
  padding: 0px 0px 10px 10px;
  margin-bottom: 10px;
}
.result_item:hover {
  cursor: pointer;
  background: #f8f9fa;
}

.item_title {
  margin: 20px 0px;
}

.title {
  width: 70%;
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  color: #5f696b;
  font-weight: 600;
}

.tag {
  display: inline-block;
  text-align: center;
  width: 30%;
}

.detail_item {
  font-size: 13px;
  margin: 13px 0px;
  color: #4e5671;
  line-height: 16px;
}
</style>